import React from 'react'
import { Box } from '@material-ui/core'
import { TaskTitleText } from './TaskItem.styled'

type TaskTitleCellProps = {
  title: string
  isCompleted: string
}

export const TaskTitle = ({ title, isCompleted }: TaskTitleCellProps) => (
  <Box>
    <TaskTitleText completed={isCompleted}>{title}</TaskTitleText>
  </Box>
)
